import type { AppState } from '../../../../types/State';

export const getStation = (state: AppState) => (state.session.radio ? state.session.radio.callSign : '');
export const getToken = (state: AppState): string => state.session.token || '';
export const isAuthenticated = (state: AppState): boolean => state.session.isAuthenticated;

export const getUserLanguage = (state: AppState): string =>
  (state.userProfile.userProfile && state.userProfile.userProfile.language)
  || (state.session.user && state.session.user.language);

export const getRadioUser = (state: AppState) => state.session.radioUser;
export const getCurrentRadio = (state: AppState) => state.session.radio;

export const getUser = (state: AppState) => state.session.user;



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/session/selectors/sessionSelectors.js